<template>
  <div v-if="isLoaded">
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2" style="height:64px">
            <h5 class="modal-title">{{$t('Subclips')}}</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager">
              <span aria-hidden="true">
                  <cancel-icon class="close-icon" style="height: 40px !important;
                      width: 40px !important;
                      color: #fff;">
                  </cancel-icon>
                </span>
            </button>
          </div>
          <div class="modal-body row">
            <div class="col-md-6 selected-thumbnail-display h-100 pl-2 p-1 m-0" style="overflow-y:auto;">
                <div class="w-100" style="/*height:350px;position:relative*/">
                   <template v-if="isVideoFile">
                          <div>
                            <PlayerAndMarkinMarkoutWrapperComponent :category_id="assetDetails.category_id" :master_asset_id="getMasterAssetId" :wrappercomponent="getWrapperComponent()">
                              <template v-slot:videomarkinmarkout>
                                <video-player @controller="setController" @playerError="handlePlayerError" @metaDataLoaded="playerFullyLoaded" :isProgressbarRequired="true" ref="videoPlayerRef" id="video-player-subclip" :playerForwardBackward="playerSteps" :options="videoOptions" style="height:100%;width:100%"/>
                                <VideoMarkinMarkoutSlider @markoutValueHasChanged="handleMarkoutChange" ref="sliderComponentRef"  @captureINframe="handleCaptureINframe"  v-on:steps="videoSteps" :playerDuration="playerDuration" v-if="playerDuration" :assetDetails="assetDetails" :markinMarkoutRef="$refs">
                                    <template v-slot:action_buttons>
                                        <MarkinMarkoutActions @manualMarkinSuccess="handleManualMarkinSuccess" @manualMarkoutSuccess="handleCaptureMarkoutClick" @clearedMarkIN_OUT="handleClearedMarkIN_OUT" @captureMarkOUTclicked="handleCaptureMarkoutClick" @showSubclipMetadata="handleShowSubclipMetadata" :isSubclipPropMutationRequired="true" :isFFbuttonRequired="true" @captureMarkINclicked="handleMarkINcapture" :isManualMarkinMarkoutEmitRequired="true" :isProgressOutTimeRequired="true" emitName="subclipPostResponse" ref="markinMarkoutActionRef" emitPlayActiveRegionName="toggleActiveItemHighlight"  @toggleActiveItemHighlight="highlightActivePlayBox"  @subclipPostResponse="subclipPostResponse" @markinMarkoutPlayerListerner="setMarkinMarkoutPlayerListener" :sliderReference="$refs" :clearMarker="clearMarker"/> 
                                    </template>
                                </VideoMarkinMarkoutSlider>
                              </template>
                            </PlayerAndMarkinMarkoutWrapperComponent>
                          </div>
                     </template>
                  <div v-if="isAudioFile" class="audio-file-with-actions-wrapper" style="display: flex; justify-content: center; flex-direction: column;">
                     <div>
                        <div style="display:flex;flex-direction:column;width:100%;">
                          <div style="height: 300px; width: 100%; display: flex; justify-content: center; align-items: center;">
                             <img style="height: 60%;" :src="getThumbnailPath(assetDetails)">
                          </div>
                          <div>

                            <CustomAudioPlayer :isPlayButtonRequired="false" @listen:completed="handleListenComplete" @audioDuration="dur => audioFileDuration = dur"  @playerPaused="handleAudioPause()" ref="customAudioPlayerRef" :fileInfo="fileInfo" style="width:100%;"></CustomAudioPlayer>
                        <!--     <audio ref="audioPlayerRef" @loadedmetadata="handleAudioMetadataloaded"  id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                                <source :src="audioUrl" type="audio/mpeg" />
                            </audio> -->
                          </div>
                        </div>
                     </div>
                     <div>
                        <MarkinMarkoutActions :fileInfo="fileInfo" :audioDuration="audioFileDuration" :buttonNotRequiredList="['framebackward','frameforward']" :isFFbuttonRequired="true" ref="audioMarkinMaroutActionRef"  :isRequiredForAudioPlayer="true" @audioEvent="handleAudioEvent"></MarkinMarkoutActions>
                     </div>
                  </div>
                  <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                  <img v-if="isImageFile"  :src="getThumbnailPath(assetDetails)" @error="replaceByDefaultImage">
                </div>
                <div class="assets-details-in-metadata-manager">
                  <div class="basic-info">
                    <ul>
                      <li>
                          <div class="key-style">Filename</div>
                          <div class="value-style" style="overflow-wrap:anywhere">{{getFileName(assetDetails)}}</div>
                      </li>
                      <li>
                          <div class="key-style">Path</div>
                          <div class="value-style" style="overflow-wrap:anywhere">{{getFilePath(assetDetails)}}</div>
                      </li>
                    </ul>
                  </div>
              </div>
            </div>
            <div class="col-md-6 p-0 h-100 metadata-fields" ref="subcliprowswrapper" v-on:scroll="loadMoreSubclips($event)" style="overflow-y:auto;">
              <!-- <div v-if="!editMetadata && (viewSubclipTypeFilters || isEnabled('Smart Subclips'))" style="display:grid;" :style="(smartSubclipJobs && Object.keys(smartSubclipJobs).length>0)?'height:95px':'height:50px'">
                <div class="d-flex" style="justify-content: space-between;padding-top: 8px;position: relative;float: inline-end;height:50px">
                    <div v-if="viewSubclipTypeFilters" class="select-filters">
                    <div v-if="viewSubclipTypeFilters" :class="{activeFilter:selectedFilter == 'All'}" @click="changeFilter('All')" class="notification-filters">{{$t('All')}}</div>
                    <div v-if="(isVideoFile || isAudioFile) && assetDetails.asset_type != 'subclip'" :class="{activeFilter:selectedFilter == 'Smart Subclips'}" @click="changeFilter('Smart Subclips')" class="notification-filters">{{$t('Smart Subclips')}}</div>
                    </div>
                    <button v-if="isEnabled('Smart Subclips')" @click="generateSmartSubclips(assetDetails)" class="btn btn-outline-primary mr-2" style="margin-inline-start:8px;inset-inline-end :0px;height: 35px;position: absolute;">Generate Smart subclips</button>
                </div>
                <div v-if="smartSubclipJobs && Object.keys(smartSubclipJobs).length>0" class="d-flex" style="width:98%;margin-top: 8px;margin: 8px;border: 1px solid #2b2b2b; border-radius: 4px;">
                    <div class="d-flex" style="padding: 8px;position: relative;float: inline-end;width: 100%;">
                    <div class="edit-upload-info mr-1 ml-1">
                        <div class="svg-icons-display">
                            <div style="position: relative; inset-inline-start :4px; width: 30px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1af3ff" viewBox="0 0 16 16" class="bi bi-input-cursor">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"></path>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"></path>
                                    <title>{{$t('Subclip')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1af3ff" viewBox="0 0 16 16" class="bi bi-input-cursor" style="position: absolute;inset-inline-end :-5px;">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"></path>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"></path>
                                    <title>{{$t('Subclip')}}</title>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div style="margin-inline-start: 11px;width: 100%;" >
                        <div class="file-name-wrapper">
                            <div class="file-name-display" :title="smartSubclipJobs.resource_name">
                                <span class="file-name-span">{{smartSubclipJobs.resource_name}}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="d-flex" style="margin-inline-end: 13px;inset-inline-end :0px;height: 35px;position: absolute;align-items: center;">
                        <div style="top: 2px;position: relative;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="smartSubclipJobs.state == 'COMPLETED'" fill="green" class="bi bi-check-circle-fill ml-2 completed-files" viewBox="0 0 16 16">
                                <title>{{$t('COMPLETED')}}</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" v-if="smartSubclipJobs.state == 'QUEUED' || smartSubclipJobs.state == 'NEW'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                <title>{{$t(smartSubclipJobs.state)}}</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            </svg>
                            <template v-if="smartSubclipJobs.state == 'FAILED' || smartSubclipJobs.state == 'ABORTED'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" class="bi bi-x-circle-fill ml-2" viewBox="0 0 16 16">
                                    <title>{{smartSubclipJobs.state}} : {{smartSubclipJobs.error_message}}</title>
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                </svg>
                            </template>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="smartSubclipJobs.state == 'INITIALIZING'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                <title>{{$t('INITIALIZING')}}</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            </svg>
                            <div v-if="smartSubclipJobs.state == 'IN_PROGRESS'" style="display:inline-flex;width:96%;justify-content:center">
                                <div class="progress" :data-percentage="parseInt(smartSubclipJobs.status_info.progress)">
                                    <span class="progress-left">
                                        <span class="progress-bar"></span>
                                    </span>
                                    <span class="progress-right">
                                        <span class="progress-bar"></span>
                                    </span>
                                    <div :id="smartSubclipJobs.job_id" class="progress-value">
                                        <div>
                                            {{parseInt(smartSubclipJobs.status_info.progress)}}%<br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div> -->
            <component v-if="!editMetadata" :is="smartSubclipComponent" :assetDetails="assetDetails" :editMetadata="editMetadata" @getSubclipsOfSelectedAssets="getSubclipsOfSelectedAssets" :isEnabled="isEnabled" :isVideoFile="isVideoFile" :isAudioFile="isAudioFile" :subclipsList="subclipsList"/>
            <div v-if="subclipsList.length && !editMetadata"  style="overflow:auto;margin-top: 5px;">
              <div v-for="clips in subclipsList" ref="subcliprows" :key="clips._id" :id="clips._id" v-on:click="selectedAssetId = clips._id;" :class="{selectedSubclipRow:selectedAssetId == clips._id}" class="display-subclips">
                <div class="actions-on-subclips">
                   <template v-if="isVideoFullyLoaded || isPlayerLoadError || isAudioFile">
                    <svg v-if="isEnabled('Transcode') && checkContext()" v-on:click.stop.prevent="enterMediaEditSection(clips)" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg);" width="1em" height="1em" fill="currentColor" class="bi bi-scissors" viewBox="0 0 16 16">
                      <path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
                      <title>Edit Media</title>
                    </svg>
                    <!-- <svg v-if="isEnabled('tag-metadata')" v-on:click.stop.prevent="openMetaDataOverlayPanel(clips._id);" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tag-fill" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                        <title>Tag Metadata</title>
                    </svg> -->
                    <svg v-if="isEnabled('Share') && isEnabled('Chat')" @click.stop.prevent="handleShareAction(clips)" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                      <title>Share In Chat</title>
                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                    </svg>
                    <svg v-on:click.stop.prevent="enterEditMode(clips._id,true)" width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-pen-fill svg-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                      <title>Edit</title>
                    </svg>
                    <delete-icon v-on:click.stop.prevent.native="deleteSelectedSubclip(clips._id)"></delete-icon>  
                   </template>
                   <template v-else>
                      <div class="loading-subclip-actions">
                         {{$t('Loading')}}....
                      </div>
                   </template>
                </div>
                  <div>
                    <div v-if="editModeOfSubclip == clips._id" style="display:flex;margin: 22px 12px;">
                        <div>
                          <div v-on:click.stop.prevent="subclipRowClicked(clips)" class="subclip-thumbnail" :style="subclipsRowsStyles.image" style="position:relative">
                                <img :src="getThumbnailOfSubclip(clips)" @error="replaceByDefaultImage" alt="Thumbnail not found" style="height:100%;width:100%;object-fit:contain;border-radius: 7px;">
                                <svg v-if="getThumbnailOfSubclip(clips) != defaultThumbnail" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-play-circle-fill play-icon" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                                </svg>
                            </div>
                          <div v-if="clips.markers" style="text-align:center;color: #319aab">{{getDurationInSecondsForMarkers(clips.markers.start) + '-' + getDurationInSecondsForMarkers(clips.markers.end)}}</div>
                        </div>
                    </div>
                    <subclips-rows v-if="editModeOfSubclip != clips._id" @editSubclipTranscript="editTranscript" @viewTrancsript="loadTranscript" :latestCapturedThumbnail="capturedInThumbnail" :isSubclipOnAudio="isAudioFile" :parentData='assetDetailsOfSubclip' :subclipsData="clips" :customStyles="subclipsRowsStyles" :selectedAssetId="selectedAssetId" @playSubclip="playSubclip" @showPreviewOnThumbnailClick="showPreviewOnThumbnailClick" @previewProxy="previewProxy"></subclips-rows>
                  </div>
              </div>
            </div>
            <div v-show="editMetadata" style="height:calc(100% - 70px);overflow:auto" id="edit_metadata_subclips_wrapper">
              <MarkinMarkoutThumbnailDisplay :capturedINthumbnail="capturedInThumbnail" :videoComponent="$refs.videoPlayerRef" v-if="markinMarkoutThumbnailObj.show"  ref="markInMarkOutThumbnail" :fileInfo="fileInfo" @capturedCanvas="(base64) => handleCaptureCanvas(base64)" :parentData="assetDetailsOfSubclip" :makinmarkout="markinMarkoutThumbnailObj" @capturedSubclipClicked="showPreviewOnThumbnailClick" :wrappercomponent="getWrapperComponent()"/>
                <div style="display:flex;margin: 4px;flex-direction:column;max-height:96%">
                  <div v-if="globalSettingsFromStartup.enable_department" class="common-input-field" style="margin-inline-start: 1%;margin-top: 20px;margin-bottom: 5px">
                    <label>{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}<span style="color:#858585"> *</span></label>
                    <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                        <div style="display: flex;flex-direction: column;align-items: end;">
                          <departmentsCommonComponent :isDropdown="true" :selectedProject="selectedDepartments" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                          <div @click="inheritFromParent()" class="manage-department-styles" style="margin-top:10px">Inherit department from parent</div>
                        </div>
                    </div>
                  </div>  
                  <div v-if="!editSubclipClicked && globalSettingsFromStartup.subclip_settings && globalSettingsFromStartup.subclip_settings.enable_hard_subclips" class="common-input-field" style="margin-inline-start: 1%;margin-top: 10px;margin-bottom: 5px">
                    <label>Path<span style="color:#858585"> *</span></label>
                    <!-- <input  type="text"  class="bg-transparent rounded text-light input-text-field"/> -->
                    <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                        <div style="display: inline-flex;">
                            <span v-if="browseType.path" class="ml-4 mr-2 add-border" style="color: #f8f9fa; margin-inline-start: 0px !important;width: 100%;
                                padding: 8px 8px;
                                border-radius: 5px;
                                margin-bottom: 3px;
                                overflow-wrap: anywhere;">{{subclipSharePath}}</span>
                            <span v-if="!browseType.path" class="ml-0 mr-2 add-border" style="color: #4f4f4f; margin-inline-start: 0px !important;width: 100%;
                                padding: 8px 8px;
                                border-radius: 5px;
                                margin-bottom: 3px;">NONE</span>
                            <browse-icon v-if="globalSettingsFromStartup.subclip_settings && globalSettingsFromStartup.subclip_settings.select_path_during_creation" v-on:click.native="openBinBrowse('path')" style="height:26px;margin-inline-start:3px;position: relative;bottom: -4px;"></browse-icon>
                        </div>
                    </div>
                  </div>  
                  <SequenceMetadataVue :parentData="assetDetailsOfSubclip" :enableMediaSlug="true" :enableOnlyFields="false" :fixMinWidth="true" :ismediaEdit="false" :enableLoadMoreFields="enableLoadMoreFields" screenType="Subclip" :defaultCategory="assetDetailsOfSubclip" @selectedCatalogFromChild="selectedCatalogFromChild" @openParentAssetDescriptionDialog="openParentAssetDescriptionDialog"  ref="sequenceMetadataModel" assetsBrowseAccess="['full-control','read-modify','read-write','read']" ></SequenceMetadataVue>
              </div>
            </div>
            <div v-if="editMetadata" class="p-0 primary-btn-style" :style="!enableLoadMoreFields?'justify-content: space-between':'justify-content: flex-end;'">
              <div v-if="!enableLoadMoreFields" v-on:click="showLoadMore()" class="load-more-btn">Load more fields</div>
              <div class="d-flex pt-2">
                <button @click.stop.prevent="cancelAddition(assetDetailsOfSubclip)" class="btn btn-outline-secondary" style="margin-inline-end:4%">Cancel</button>
                <button @click.stop.prevent="addSubclip(assetDetailsOfSubclip)" class="btn btn-outline-primary mr-2">Save</button>
              </div>
            </div>
            <div v-if="!editMetadata && subclipsList.length == 0" class="outer">
              <div class="middle">
                <div class="inner">
                  <img :src="noDataFoundImage" alt="No Subclips Found" style="opacity:0.4">
                  <p>No Subclips yet!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <ShareInChat class="share-in-chat-subclip" v-if="openShareInChat" :fileInfo="assetDetailsOfSubclip" @close="closeShareInChat()"></ShareInChat>
    </div>
    <parentDescDialog v-if="showParentDescriptionDialog" :fileInfo="assetDetails" @closeDialog="closeDialog"></parentDescDialog>
    <fileBrowseModel
        v-if="isActiveBinBrowse"
        :workspaceList="browseWorkspaceList"
        :enableAssetMultiSelect="false"
        @close="closeCatalogBrowse"
        @handleFilesBrowse="selectedBinPath"
        :enableRecursive="false"
        :browseOnlyFolders="true"
        style="z-index:99"
        ></fileBrowseModel>
        <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(9999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"  :disablePreviewDocker="true"></picture-in-picture>
        <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(9999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
        v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
        <MiniPlayer @closeMiniPlayer="isMiniPlayerVisible = false;openPip = false;" v-if="isMiniPlayerVisible" :transcriptPlayObject="transcriptPlayObject" ref="miniPlayerRef"  :selectedFile="fileInfo"></MiniPlayer>
    <router-view 
      class="media-edit-with-subclips"
      :data-component="selectedComponent"
      :name="selectedComponent" 
      :fileInfo="assetDetails"
      :selectedSubclip="selectedSubclip?selectedSubclip:{}">
    </router-view>
  </div>
</template>
<script>
import CancelIcon from "../core/InlineCancelField.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import "vue2-datepicker/index.css";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Utils from "../../components.utils.js"
// import tagMetadataComponent from "../files/TagMetadataComponent.vue"
import VideoMarkinMarkoutSlider from '../core/VideoMarkinMarkoutSlider.vue';
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import MarkinMarkoutActions from '../markinMarkout/MarkinMarkoutActions.vue';
import PlayerAndMarkinMarkoutWrapperComponent from '../markinMarkout/PlayerAndMarkinMarkoutWrapperComponent.vue';
import MarkinMarkoutThumbnailDisplay from '../markinMarkout/MarkinMarkoutThumbnail.vue';
// import backButton from "../core/backButton.vue";
import subclipRows from "./SubclipsRows.vue";
import deleteIcon from "../core/InlineDeleteIcon.vue";
import Constants from "../../components.constants.js";
import {NotifierConstants} from "../../components.constants.js";
import ShareInChat from "../core/ShareInChat.vue";
import SequenceMetadataVue from '../files/SequenceMetadata.vue';
import parentDescDialog from "./copyParentDescription.vue";
import BrowseIcon from "../core/InlineBrowseField.vue";
import fileBrowseModel from "../files/filesBrowse.vue";
import MiniPlayer from '../files/MiniPlayer.vue';
import pictureInPicture from "../files/MiniPlayer.vue";
import imagePreview from "../core/ImagePreviewDialog.vue";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";
import CustomAudioPlayer from '../customAudioPlayer/AudioPlayerComponent.vue';

export default {
  mixins:[RangeSliderMixins],
  props:["fileInfo"],
  name:'bin-sub-clips-manager',
  data() {
    return {
    //   selectedFilter:'All',
    //   viewSubclipTypeFilters:false,
      selectedDepartments:[],
      browseWorkspaceList:[Constants.WORKSPACE_BINS],
      browseType:{catalog:'',path:'',type:''},
      clearMarker:false,
      isLoaded:false,
      assetId:null,
      time:null,
      assetDetails:{},
      assetDetailsOfSubclip:{},
      subclipsList:[],
      slugName: "",
      route:"",
      editingMetadataKeyInDock:null,
      assetCustomMetadata : {"custom_metadata":[]},
      selectedComponent:null,
      selectedSubclip:null,
      categoryDetails:{name:"",id:""},
      subclipsRowsStyles:{
        slugFontSize:{"font-size":"20px"},
        duration:{"font-size":"19px"},
        image:{"width":"345px"}
      },
      categoryName:"",
      actionsOnPlayer: false,
      editMetadata:false,
      audioUrl:null,
      controller:{},
      videoOptions: {
          autoplay: false,
          controls: true,
          nativeTextTracks: true,
          controlBar:{
                'pictureInPictureToggle': false,
                'progressControl': false,
                'remainingTimeDisplay': false,

            volumePanel: {
                inline: false,
                vertical: true
            },

            playToggle: false
        },
        preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
				sources: []
			},
      noDataFoundImage:Utils.getNoDataFoundImg(),
      selectedAssetId:null,
      page:1,
      totalSubclipsPages:-1,
      parentRouteInfo:{},
      fileId:null,
      tagIcon:Utils.getTagSvg(),
      editModeOfSubclip:null,
      thumbnail:Utils.getNoThumbnailImg(),
      defaultThumbnail:Utils.getNoThumbnailImg(),
      slugNameData:null,
      descriptionData:null,
      openShareInChat:false,
      progressElMap:{},
      componentName: null,
      enableLoadMoreFields:false,
      selectedCatalogsArr:[],
      showParentDescriptionDialog:false,
      frameRate: 25,
      editSubclipClicked:false,
      latestCapturedThumbnail:null,
      playerDuration:null,
      isActiveBinBrowse:false,
      subclipSharePath:'',
      selectedFileInfo:{},
      openPip:false,
      showOtherFilesPreviewDialog:false,
      isMiniPlayerVisible: false,
      audioMarkers:{start:null,end:null},
      audioFileDuration:null,
    //   smartSubclipJobs:null,
      smartSubclipComponent:null,
      transcriptPlayObject:{},
      isINThumbnailCaptured: false,
      capturedInThumbnail:null,
      assetIndividualGetPromise:null,
      isVideoFullyLoaded: false,
      isPlayerLoadError:false,
    };
  },
  components:{
    "cancel-icon": CancelIcon,
    VideoPlayer: VideoPlayer,
    // "tag-metadata": tagMetadataComponent,
    // "back-icon":backButton,
    "subclips-rows":subclipRows,
    "delete-icon":deleteIcon,
    VideoMarkinMarkoutSlider,
    MarkinMarkoutActions,
    PlayerAndMarkinMarkoutWrapperComponent,
    MarkinMarkoutThumbnailDisplay,
    ShareInChat,
    SequenceMetadataVue,
    parentDescDialog,
    "browse-icon" : BrowseIcon,
    fileBrowseModel,
    MiniPlayer,
    "picture-in-picture":pictureInPicture,
    "ImagePreviewDialog":imagePreview,
    departmentsCommonComponent,
    CustomAudioPlayer
  },
  computed:{
      isHardsubclip(){
          if(this.assetDetailsOfSubclip && typeof this.assetDetailsOfSubclip == 'object'
            && 'subclip_type' in this.assetDetailsOfSubclip &&  this.assetDetailsOfSubclip.subclip_type == 'hard'){
             return true;
          }
          return false;
      },
      globalSettingsFromStartup:{
        get(){
          console.log("this.$store.state.startUpData.startUpDataDetails",this.$store.state.startUpData.startUpDataDetails)
          return this.$store.state.startUpData.startUpDataDetails;
        }
      },
     getMasterAssetId(){
        if('asset_id' in this.assetDetails){
          return this.assetDetails.asset_id;
        }else{
          return this.assetDetails._id;
        }
      },
    isAudioFile(){
        try {
            return this.assetDetails.mime_type.startsWith("audio")   
            
        } catch (err) {
            console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    isVideoFile(){
        try {
            return this.assetDetails.mime_type.startsWith("video")   
        } catch (err) {
            console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    isImageFile(){

        try {
            return this.assetDetails.mime_type.startsWith("image") || this.assetDetails.mime_type.startsWith("doc")
        } catch (err) {
            console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    selectedAssetInfo(){
      return {assetDetailsFromParent:this.assetDetailsOfSubclip}
    },
...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserId"])
  },
  methods: {
    handlePlayerError(){
        this.isPlayerLoadError = true;
    },
    async playerFullyLoaded() {
        this.isVideoFullyLoaded = true;
        if(!this.assetIndividualGetPromise) return;
        try {
          await this.assetIndividualGetPromise;

          await this.$nextTick();

          const md = this.assetDetailsOfSubclip;
          const markers = md && md.markers;

          if(
            this.editMetadata &&
            md &&
            Object.keys(md).length > 0 &&
            markers &&
            typeof markers === 'object' &&
            markers.start != null &&
            markers.end != null){
              this.setCaptureFrameInfo(md);
          }
        } catch (err) {
          console.error('[playerFullyLoaded] asset fetch or processing failed', err);
        } finally {
          // clear so a later load doesn't re-await a stale, already-settled promise
          this.assetIndividualGetPromise = null;
        }
    },
    handleClearedMarkIN_OUT(){
      console.log("[handleClearedMarkIN_OUT]......");
        if(this.isHardsubclip && this.editMetadata) return;
        this.capturedInThumbnail = this.getThumbnailPath(this.assetDetails);
        try{
           if(this.markinMarkoutThumbnailObj.show){
              setTimeout(()=>{
                 //this.capturedInThumbnail = this.captureInFrameWithoutMetadataPanel();
                 this.$refs.markInMarkOutThumbnail.setINThumbnail(this.getThumbnailPath(this.assetDetails));
              },50);
           }
        }catch(e){console.log(e)}
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if('markers' in this.assetDetailsOfSubclip){
        this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
        this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
        /*
        if(this.$refs.sequenceMetadataModel){
            this.$refs.sequenceMetadataModel.updateMediaValue(this.assetDetails.slug_name + '_' + parseInt(this.$refs.sliderComponentRef.value[0]) + '_' + parseInt(this.$refs.sliderComponentRef.value[1]));
        }*/
      }
      this.isINThumbnailCaptured = true;
    },
    handleMarkoutChange(markoutValue){
      console.log("[handleMarkoutChange] markoutValue",markoutValue);
      if(this.isHardsubclip) return;
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if('markers' in this.assetDetailsOfSubclip){
        this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
        this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
        /*
        if(this.$refs.sequenceMetadataModel){
            this.$refs.sequenceMetadataModel.updateMediaValue(this.assetDetails.slug_name + '_' + parseInt(this.$refs.sliderComponentRef.value[0]) + '_' + parseInt(this.$refs.sliderComponentRef.value[1]));
        }*/
      }
    },
    handleShowSubclipMetadata(){
      const getThumbnailDisplayDuration = ()=>{
          let videoDuration1 = this.playerDuration;
          let videoDuration = String(videoDuration1).slice(0,7);
          console.log("=============", videoDuration)
          let count = videoDuration.indexOf(".");
          console.log("===============", count)
          count = 1 - count;
          console.log("===============", count)
          count = Math.pow(10, 2);
          console.log("===============", count)
          let durationId = "00".concat(String(videoDuration * 2));
          console.log("*******", durationId);
          return durationId;
      }
      if(this.editMetadata){
        alert("You have unsaved metadata, please save or cancel before continuing");
        return false;
      }
      try{
        let slugName = this.assetDetails.slug_name + getThumbnailDisplayDuration();
        this.$set(this.markinMarkoutThumbnailObj,'dur',`${Utils.getDurationInSeconds(this.$refs.sliderComponentRef.value[0])} - ${Utils.getDurationInSeconds(this.$refs.sliderComponentRef.value[1])}`);
        this.$set(this.markinMarkoutThumbnailObj,'filename',slugName);
      }catch(e){console.log(e)}
       this.editMetadata = true;
       this.markinMarkoutThumbnailObj.show = true;
       const postSubclip = (thumbnail) =>{
          return new Promise((resolve)=>{
            let payload = {};
            payload['slug_name'] = '';
            payload['category_id'] = null;
            payload['asset_type'] = 'subclip';
            payload['markers'] = {...this.$refs.sliderComponentRef.getStartEndTime(),"frame_thumbnail_uri":thumbnail};
            payload['master_asset_id'] = this.getMasterAssetId;
            let IN = parseInt(this.$refs.sliderComponentRef.value[0]);
            let OUT = parseInt(this.$refs.sliderComponentRef.value[1]);
            let originalSlugName = this.assetDetails?.slug_name;
            try{
               originalSlugName = originalSlugName.replace("_${IN}_${OUT}","").replace("_${IN}","").replace("_${OUT}","");
            }catch(e){console.log(e)}
            let slugName = this.assetDetails?.slug_name;
            slugName = slugName.replace(/\$\{IN\}/g,  IN).replace(/\$\{OUT\}/g, OUT);
            payload.slug_name = slugName;
            this.insertSubClip(payload).then((res) =>{
                console.log("[insertSubClip insertSubClip]",res);
                resolve(res);
                this.assetDetailsOfSubclip = res.upserted_data;
                if(this.assetDetailsOfSubclip && 'slug_name' in this.assetDetailsOfSubclip){
                    this.assetDetailsOfSubclip.slug_name = originalSlugName + '_${IN}_${OUT}';
                }
                this.markinMarkoutThumbnailObj.frames[res.upserted_data._id] = res.upserted_data;
                this.editModeOfSubclip = res.upserted_data._id;
                this.slugNameData = this.assetDetailsOfSubclip.slug_name;
                this.selectedAssetId = this.assetDetailsOfSubclip._id;
                let payload = {}
                payload.params = {assetId: this.selectedAssetId}
                this.getAssetInfoFromServer(payload).then((data) => {
                    this.assetDetailsOfSubclip =  data.asset;
                    try{
                      if(this.assetDetailsOfSubclip && 'slug_name' in this.assetDetailsOfSubclip){
                          this.assetDetailsOfSubclip.slug_name = originalSlugName + '_${IN}_${OUT}';
                      }
                    }catch(e){console.log(e)}
                    if(this.assetDetailsOfSubclip.department_info) {
                      this.selectedDepartments = this.assetDetailsOfSubclip.department_info;
                    }else{
                      this.selectedDepartments = [];
                    }
                    this.editMetadata = true;
                })
            })
          })
       }
       postSubclip(this.capturedInThumbnail).then((data)=>{
          console.log("data...............",data);
       });
    },
    handleManualMarkinSuccess(time){
        console.log("handleManualMarkinSuccess",time);
        if(!this.$refs.videoPlayerRef) return;
        const video = this.$refs.videoPlayerRef.$el.querySelector('video');
        const playerSeekedHandler = () => {
          // runs once, after the seek completes
          this.handleMarkINcapture(true, time * 1000); //@params isManualMarkinMarkout , markin
          this.$refs.sliderComponentRef.setPositionFromValue(time * 1000); // in milliseconds
        };
        video.removeEventListener('seeked', playerSeekedHandler);
        video.addEventListener('seeked', playerSeekedHandler, { once: true });
        video.currentTime = time;
    },
    handleMarkINcapture(isManualMarkinMarkout = false,markin=null){
      if(this.isHardsubclip && this.editMetadata) return;
      let isvideoPlaying = false;
      try{
       if(!this.$refs.videoPlayerRef.$el.querySelector('video').paused){
         isvideoPlaying = true;
         this.$refs.videoPlayerRef.$el.querySelector('video').pause();
       }
      }catch(e){console.log(e)}
      this.isINThumbnailCaptured = true;
      if(this.markinMarkoutThumbnailObj.show){
          try{
              this.capturedInThumbnail = this.captureInFrameWithoutMetadataPanel();
              this.$refs.markInMarkOutThumbnail.setINThumbnail(this.capturedInThumbnail);
          }catch(e){console.log(e)}
          this.capturedInThumbnail = this.$refs.markInMarkOutThumbnail.displayThumbnail(true,true);
      }else{
         this.capturedInThumbnail = this.captureInFrameWithoutMetadataPanel();
      }
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if('markers' in this.assetDetailsOfSubclip){
        this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
        this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
        /*
        if(this.$refs.sequenceMetadataModel){
            this.$refs.sequenceMetadataModel.updateMediaValue(this.assetDetails.slug_name + '_' + parseInt(this.$refs.sliderComponentRef.value[0]) + '_' + parseInt(this.$refs.sliderComponentRef.value[1]));
        }*/
         if(isManualMarkinMarkout && markin){ //overwrite markin , done to match both timestamps 
             this.assetDetailsOfSubclip['markers']['start'] = markin;
             if(markObj.end){
                this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
             }
         }
      }
      try{
        if(isvideoPlaying){ //pause for 30milliseconds for better capturing
          setTimeout(()=>{
              this.$refs.videoPlayerRef.$el.querySelector('video').play();
          },30);
        }
      }catch(e){console.log(e)}
    },
    handleCaptureMarkoutClick(isManualMarkinMarkout = false,markout=null){
      console.log("[handleCaptureMarkoutClick]",isManualMarkinMarkout,markout);
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if(!this.isHardsubclip && 'markers' in this.assetDetailsOfSubclip){
        if(isManualMarkinMarkout && markout){ //overwrite markout , done to match both timestamps 
             this.assetDetailsOfSubclip['markers']['end'] = markout;
        }else{
          this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
          this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
        }
      }
    },
    handleCaptureCanvas(base64){
        console.log("[handleCaptureCanvas]");
       if(this.isINThumbnailCaptured){
          this.captureCanvas(this.capturedInThumbnail);
       }else{
          this.captureCanvas(base64);
       }
    },
    captureInFrameWithoutMetadataPanel(){
        const video = this.$refs.videoPlayerRef.$el.querySelector('video');
        if (!video || video.readyState < 2) {
          // HAVE_CURRENT_DATA not reached yet — nothing to draw
          console.warn('Video frame not available yet');
          return;
        }

        // Downscale to keep the blob small (320px wide, like your thumbnail flow)
        const targetWidth = 320;
        const scale = targetWidth / video.videoWidth;
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = Math.round(video.videoHeight * scale);

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Option A: data URL (quick preview / small images)
         try{
            this.markinMarkoutThumbnailObj.thumbnail = '';
         }catch(e){console.log(e)}
         return canvas.toDataURL('image/jpeg', 0.85);
    },
    handleCaptureINframe(){
      console.log("handleCaptureINframe handleCaptureINframe called.....");
      // if (this.markinMarkoutThumbnailObj.show) {
        const player = this.controller.player;

        // clean up any stale listeners from a previous call
        player.off('seeked', this._seekedCaptureHandler);
        player.off('waiting', this._waitingHandler);
        player.off('canplay', this._canplayHandler);

        const targetTime = player.currentTime();
        console.log('handleCaptureINframe start, targetTime:', targetTime, 'seeking:', player.seeking(), 'readyState:', player.readyState());

        const runCapture = () => {
          player.off('waiting', this._waitingHandler);
          player.off('canplay', this._canplayHandler);
          this.captureFrameAndDisplay(targetTime);
        };

        this._seekedCaptureHandler = () => {
          console.log('seeked fired, currentTime:', player.currentTime());
          runCapture();
        };

        // in case seeking backward stalls on an unbuffered region,
        // canplay after a waiting state is our fallback signal
        this._waitingHandler = () => console.log('waiting fired (buffer stall)');
        this._canplayHandler = () => {
          console.log('canplay fired, currentTime:', player.currentTime());
          if (Math.abs(player.currentTime() - targetTime) < 0.5) {
            runCapture();
          }
        };

        if (player.seeking()) {
          player.one('seeked', this._seekedCaptureHandler);
          player.on('waiting', this._waitingHandler);
          player.on('canplay', this._canplayHandler);
        } else {
          runCapture();
        }
      // }
    },

  captureFrameAndDisplay(targetTime){
    if(this.isHardsubclip && this.editMetadata) return;
    const player = this.controller.player;
    const techEl = player.tech({ IWillNotUseThisInPlugins: true }).el();
    const target = targetTime ?? player.currentTime();

    if (!techEl.requestVideoFrameCallback) {
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if('markers' in this.assetDetailsOfSubclip){
        this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
        this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
      }
      /*
      try{
        if(this.$refs.sequenceMetadataModel){
           this.$refs.sequenceMetadataModel.updateMediaValue(this.assetDetails.slug_name + '_' + parseInt(this.$refs.sliderComponentRef.value[0]) + '_' + parseInt(this.$refs.sliderComponentRef.value[1]));
        }
      }catch(e){console.log(e)}
      */
      if(this.markinMarkoutThumbnailObj.show){
        this.isINThumbnailCaptured = true;
        this.capturedInThumbnail = this.$refs.markInMarkOutThumbnail.displayThumbnail(true,true);
      }else{
        this.capturedInThumbnail = this.captureInFrameWithoutMetadataPanel();
      }
      return;
    }

    let resolved = false;

    const finish = (reason, mediaTime) => {
      if (resolved) return;
      resolved = true;
      console.log('captured via', reason, 'mediaTime:', mediaTime, 'target:', target);
      let markObj = this.$refs.sliderComponentRef.getStartEndTime();
      if(!this.isHardsubclip && 'markers' in this.assetDetailsOfSubclip){
        this.assetDetailsOfSubclip['markers']['start'] = markObj.start;
        this.assetDetailsOfSubclip['markers']['end'] = markObj.end;
      }
      /*
      try{
        if(this.$refs.sequenceMetadataModel){
           this.$refs.sequenceMetadataModel.updateMediaValue(this.assetDetails.slug_name + '_' + parseInt(this.$refs.sliderComponentRef.value[0]) + '_' + parseInt(this.$refs.sliderComponentRef.value[1]));
        }
      }catch(e){console.log(e)}
      */
      if(this.markinMarkoutThumbnailObj.show){
        this.isINThumbnailCaptured = true;
        this.capturedInThumbnail = this.$refs.markInMarkOutThumbnail.displayThumbnail(true,true);
      }else{
         this.capturedInThumbnail = this.captureInFrameWithoutMetadataPanel();
      }
    };

    // primary path: wait for the one frame the seek actually produces
    techEl.requestVideoFrameCallback((now, metadata) => {
      finish('rVFC', metadata.mediaTime);
    });

    // safety net: if rVFC never fires (paused video, no new frame),
    // capture anyway after a short wait rather than hanging forever
    setTimeout(() => {
      finish('timeout-fallback', player.currentTime());
    }, 150);
  },

  sortTranscriptBasedOnTime(arr = []){
      return arr.sort((a,b)=>{
        if (a.media_in !== b.media_in) {
          return a.media_in - b.media_in;
        } else {
          return a.media_out - b.media_out;
        }
      });
    },
    async loadTranscript(subclip){
      let data = await this.getSubclipTransctiptFromServer({params:{asset_id:subclip.asset_id, asset_type:'subclip'}})
      let indx = this.subclipsList.findIndex(op=>op.asset_id == subclip.asset_id)
      if(indx >= 0){
        if(data.transcript){
          this.$set(this.subclipsList[indx], 'transcript', this.sortTranscriptBasedOnTime(data.transcript.transcript))
        }else{
          this.$set(this.subclipsList[indx], 'transcript', [])
        }
      }
    },
    getglobalSearchedValue(){
      return "";
    },
    handleListenComplete(){
        this.$refs.audioMarkinMaroutActionRef.resetActivePreview();
    },
    handleAudioMetadataloaded(){
       this.$refs.audioMarkinMaroutActionRef.markoutPlaceholderValue = Utils.getExactDuationInSeconds(this.$refs.audioPlayerRef.currentTime);
    },
    handleAudioPause(){
        this.$refs.customAudioPlayerRef.getAudioPlayer().pause();
        this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(false);
    },
    handleVideoPlay(){
        this.$refs.customAudioPlayerRef.getAudioPlayer().play();
        this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(true);
    },
    handleAudioPlayPause(){
       //this.$refs.customAudioPlayerRef.playPuseAudio();
       if(this.$refs.customAudioPlayerRef.getAudioPlayer()){
          if(this.$refs.customAudioPlayerRef.getAudioPlayer().paused){
              this.$refs.customAudioPlayerRef.getAudioPlayer().play();
              this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(true);
          }else{
             this.$refs.customAudioPlayerRef.getAudioPlayer().pause();
             this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(false);
          }
       }
    },
    handleAudioMarkinAdd(){
      this.$refs.customAudioPlayerRef.setMarkinMarker();
      let currtTime = this.$refs.customAudioPlayerRef.currentTime;
      console.log(`currtTime`,currtTime);
      this.$refs.audioMarkinMaroutActionRef.setMarkinDurationValue(parseInt(currtTime * 1000));
      this.audioMarkers.start = parseInt(currtTime * 1000);
      this.$refs.audioMarkinMaroutActionRef.setMarkinLabelValue(currtTime);
     // this.$refs.audioPlayerRef.pause();
      //this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(false);
    },
    handleAudioMarkoutAdd(){
      try{
        const inVal = this.$refs.customAudioPlayerRef.inMarkerValue;
        if(!inVal){
           alert(this.$t("Empty IN value")+".");
           return;
        }
        const outVal = this.$refs.customAudioPlayerRef.getAudioPlayer().currentTime * 1000; //millisecond
        if(Number.isFinite(outVal) && Number.isFinite(inVal) && outVal < inVal) {
          this.$refs.customAudioPlayerRef.outMarkerValue = null;
          alert(this.$t("Out value is less than IN value")+".");
          return;
        }
      }catch(e){console.log(e)}
      this.$refs.customAudioPlayerRef.setMarkoutMarker();
      let currtTime = this.$refs.customAudioPlayerRef.currentTime;
      console.log(`currtTime`,currtTime);
      this.$refs.audioMarkinMaroutActionRef.setMarkoutDurationValue(parseInt(currtTime * 1000));
      this.audioMarkers.end = parseInt(currtTime * 1000);
      this.$refs.audioMarkinMaroutActionRef.setMarkoutLabelValue(currtTime);
      this.$refs.customAudioPlayerRef.getAudioPlayer().pause();
      this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(false);
    },
    handleAudioSubclipPost(){
      if(!this.audioMarkers.start){
         alert("No Markin.");
         return;
      }
      let payload = {
        asset_type:"subclip",
        markers:{},
        master_asset_id: this.assetId,
        slug_name : this.getFileName(this.fileInfo)
      };
      try{
        if(this.$refs.customAudioPlayerRef && this.$refs.customAudioPlayerRef.inMarkerValue != null){
           payload.slug_name = this.getFileName(this.fileInfo) + '_'+this.$refs.customAudioPlayerRef.inMarkerValue;
        }
        if(this.$refs.customAudioPlayerRef && this.$refs.customAudioPlayerRef.inMarkerValue != null 
            && this.$refs.customAudioPlayerRef.outMarkerValue){
            if(this.$refs.customAudioPlayerRef.inMarkerValue != this.$refs.customAudioPlayerRef.outMarkerValue){
              payload.slug_name = this.getFileName(this.fileInfo) + '_'+this.$refs.customAudioPlayerRef.inMarkerValue + '_'+this.$refs.customAudioPlayerRef.outMarkerValue;
            }else{
              payload.slug_name = this.getFileName(this.fileInfo) + '_'+this.$refs.customAudioPlayerRef.inMarkerValue;
            }
        }
      }catch(e){console.log(e)}
      if(this.$refs.customAudioPlayerRef && this.$refs.customAudioPlayerRef.inMarkerValue != null){
        payload.markers['start'] = this.$refs.customAudioPlayerRef.inMarkerValue;
        payload.markers['end'] = this.$refs.customAudioPlayerRef.inMarkerValue; // this value will be overriden below
      }
      if(this.$refs.customAudioPlayerRef && this.$refs.customAudioPlayerRef.outMarkerValue != null){
         payload.markers['end'] = this.$refs.customAudioPlayerRef.outMarkerValue;
      }
      payload.markers['mime_type'] = 'audio';
      console.log(payload);
     // this.setCaptureFrameInfo({});
      this.insertSubClip(payload).then((response) =>{
          console.log(`[insertSubClip]`,response);
          if(!Utils.isAcceptedStatusCode(response.statusCode)){
              this.$toast.error(response.message);
          }
          this.enterEditMode(response.upserted_data._id,false,'AUDIO_CAPTURE');
      }); 
    },
    handleClearMakers(){
   /*     if(this.$refs.audioPlayerRef){
          this.$refs.audioPlayerRef.currentTime = 0;
          this.$refs.audioPlayerRef.pause();
       } */
       this.$refs.customAudioPlayerRef.restMarkinMarkoutMarkers();
       this.$refs.audioMarkinMaroutActionRef.clearAudioMarkers();
    },
    playAudioMarkinMarkoutPreview(){
       if(!this.audioMarkers.start){
          alert('No Markin');
          return;
       }
      if(!this.audioMarkers.end){
          alert('No Markout');
          return;
       }
        this.$refs.customAudioPlayerRef.setPreviewState(true);
        this.$refs.audioMarkinMaroutActionRef.isActivePreview = true;
        //this.$refs.audioPlayerRef.currentTime = this.audioMarkers.start / 1000;
        //this.$refs.audioPlayerRef.play();
        this.$refs.audioMarkinMaroutActionRef.setPlayPauseState(true);
        this.$refs.customAudioPlayerRef.listenAudioBetweenMarkers();
    },
    handleAudioForwardBackward1Sec(action){
       let dur = this.$refs.customAudioPlayerRef.getAudioPlayer().duration;
       let curDur = this.$refs.customAudioPlayerRef.getAudioPlayer().currentTime;
       if (dur != undefined && curDur != undefined) {
            //forward 1 second
            if (action == "forward" && curDur < (dur + 1)) {
                this.$refs.customAudioPlayerRef.getAudioPlayer().currentTime = curDur + 1;
            }
            //backward 1 second
            if (action == "backward" && curDur > 1) {
                this.$refs.customAudioPlayerRef.getAudioPlayer().currentTime = (curDur -1);
            }
       }
    },
    handleAudioForwardBackwardByFrame(action){
      let dur = this.$refs.audioPlayerRef.duration;
      let curDur = this.$refs.audioPlayerRef.currentTime;
       if(dur && action == "forward"  && curDur == 0){
            this.$refs.audioPlayerRef.currentTime = (curDur + 0.04 + 0.001);
            return;
        }
       if (dur != undefined && curDur != undefined) {
            //forward 1 frame
            if (action == "forward" && curDur < (dur + 0.04)) {
                this.$refs.audioPlayerRef.currentTime = curDur + 0.04;
            }
            //backward 1 frame
            if (action == "backward" && curDur > 0.04) {
                this.$refs.audioPlayerRef.currentTime = (curDur -0.04);
            }
       }
    },
    handleSetMarkinValue(timeInMillisecond){
      if(timeInMillisecond && (this.$refs.customAudioPlayerRef.getAudioPlayer().duration >= (timeInMillisecond/1000))){
        // this.$refs.customAudioPlayerRef.getAudioPlayer().currentTime = timeInMillisecond/1000;
         this.audioMarkers.start = timeInMillisecond;
         this.$refs.audioMarkinMaroutActionRef.setMarkinDurationValue(timeInMillisecond);
        //  this.$refs.audioMarkinMaroutActionRef.setMarkinLabelValue(timeInMillisecond / 1000);
         this.$refs.audioMarkinMaroutActionRef.markinDurationValue = this.$refs.audioMarkinMaroutActionRef.formatDurationHHMMSS_withoutFrame(timeInMillisecond / 1000);
         this.$refs.customAudioPlayerRef.setMarkinMarker(timeInMillisecond);
      }
    },
    handleSetMarkoutValue(timeInMillisecond){
      if(timeInMillisecond && (this.$refs.customAudioPlayerRef.getAudioPlayer().duration >= (timeInMillisecond/1000))){
         this.audioMarkers.end = timeInMillisecond;
         this.$refs.audioMarkinMaroutActionRef.setMarkoutDurationValue(timeInMillisecond);
         //this.$refs.audioMarkinMaroutActionRef.setMarkoutLabelValue(timeInMillisecond / 1000);
         this.$refs.audioMarkinMaroutActionRef.markoutDurationValue = this.$refs.audioMarkinMaroutActionRef.formatDurationHHMMSS_withoutFrame(timeInMillisecond / 1000);
         this.$refs.customAudioPlayerRef.setMarkoutMarker(timeInMillisecond);
      }
    },
    handleAudioEvent(eventType='',action=''){
      console.log(`handleAudioEvent`,eventType,action);
      if(eventType == 'stopPlayPause'){
         this.handleAudioPlayPause();
      }
      if(eventType == 'addMarkin'){
         this.handleAudioMarkinAdd();
      }
      if(eventType == 'addMarkout'){
        this.handleAudioMarkoutAdd();
      }
      if(eventType == 'addSubclip'){
        this.handleAudioSubclipPost();
      }
      if(eventType == 'clear'){
        this.handleClearMakers();
      }
      if(eventType == 'playMarkinMarkoutPreview'){
         this.playAudioMarkinMarkoutPreview();
      }
      if(eventType =='forwardBackwardVideoBy1Sec'){
          this.handleAudioForwardBackward1Sec(action);
      }
      if(eventType =='setMarkinValue'){
          console.log('setMarkinValue',action);
          this.handleSetMarkinValue(action);
      }
      if(eventType == 'setMarkoutValue'){
          console.log('setMarkoutValue',action);
          this.handleSetMarkoutValue(action);
      }
      // if(eventType =='forwardBackwardVideoByFrame'){
      //     this.handleAudioForwardBackwardByFrame(action);
      // }
    },
    listenAudioClickedRow(clipInfo){
      this.audioMarkers.start = clipInfo.markers.start;
      this.audioMarkers.end = clipInfo.markers.end;
      this.$refs.customAudioPlayerRef.setMarkinMarker(clipInfo.markers.start,()=>{
          this.$refs.audioMarkinMaroutActionRef.setMarkinDurationValue(clipInfo.markers.start);
          this.$refs.audioMarkinMaroutActionRef.setMarkoutDurationValue(clipInfo.markers.end);
          this.$refs.audioMarkinMaroutActionRef.setMarkinLabelValue(clipInfo.markers.start / 1000);
          this.$refs.audioMarkinMaroutActionRef.setMarkoutLabelValue(clipInfo.markers.end / 1000);

          this.$refs.customAudioPlayerRef.setMarkoutMarker(clipInfo.markers.end);
          this.playAudioMarkinMarkoutPreview();
      });
    },
    inheritFromParent(){
      if(this.assetDetails.department_info && this.assetDetails.department_info._id){
        this.selectedDepartments =  this.assetDetails.department_info;
      }else{
        this.selectedDepartments = []
      }
    },
    selectedBinPath(folderInfoList){
      if(folderInfoList && folderInfoList.length > 0){
        this.isActiveBinBrowse = false;
        this.browseType.path = true;
        this.subclipSharePath = folderInfoList[0].path;
      }else{
        console.log("Failed to update the browsed folder path:",folderInfoList)
      }
    },
    openBinBrowse(){
        this.isActiveBinBrowse = true;
    },
    closeCatalogBrowse(){
        this.isActiveBinBrowse = false;
    },
     showPreviewOnThumbnailClick(info){
         console.log(`showPreviewOnThumbnailClick`,info);
        this.playMarkinMarkout(info,true);
     },
     isMediaEditWindowEvent(){
       const names = [
            "PartialRetrieve-from-metadata-dock","PartialRetrieve","asset-PartialRetrieve","subclip-asset-partial-retrieve",
            "tagmetadata-subclip-asset-partial-retrieve-as-child","metadata-dock-partial-retrieve","metadata-dock-subclip-asset-partial-retrieve-as-child",
            "subclip-asset-PartialRetrieve","asset-PartialRetrieve-as-child","PartialRetrieve","subclip-partial-retrieve",
            "metadata-dock-subclip-partial-retrieve-as-child","PartialRetrieve-as-child","tagmetadata-subclip-partial-retrieve-as-child"
        ];

       return names.indexOf(this.$route.name) > -1;
     },
      showLoadMore(){
        setTimeout(() => {
          document.getElementById("edit_metadata_subclips_wrapper").scrollBy(0, 150)
        }, 200);
        this.enableLoadMoreFields = true;
      },
      closeDialog(){
        this.showParentDescriptionDialog = false;
      },
      openParentAssetDescriptionDialog(){
        this.showParentDescriptionDialog = true;
      },
      selectedCatalogFromChild(catalog){
          this.selectedCatalogsArr = catalog;
      },
      stopPlayerIfPlaying(){
         try{
           if(!this.controller.player.paused()){
                this.controller.player.pause();
           }
        }catch(e){console.log(e)}
      },
      getDurationInSeconds(duration){
          let regex = new RegExp(":")
          if(regex.test(duration)){
              return duration;
          }
         return duration/1000;
      },
      getDurationInSecondsForMarkers(duration){
          return Utils.getExactDuationInSeconds(this.getDurationInSeconds(duration))
      },
      enterMediaEditSection(selectedSubclip){
        try{
           if(!this.controller.player.paused()){
                this.controller.player.pause();
           }
        }catch(e){console.log(e)}
        this.selectedSubclip = selectedSubclip;
        if(this.$route.name == 'sub-clips-manager'){
          this.selectedComponent = "subclip-asset-partial-retrieve";
        }else if(this.$route.name == 'sub-clips-manager-as-child'){
          this.selectedComponent = "tagmetadata-subclip-asset-partial-retrieve-as-child";
        }else if(this.$route.name == 'bin-sub-clips-manager'){
          this.selectedComponent = "subclip-partial-retrieve";
        }else if(this.$route.name == 'bin-sub-clips-manager-as-child'){
          this.selectedComponent = "tagmetadata-subclip-partial-retrieve-as-child";
        }else if(this.$route.name == 'metadata-dock-sub-clips-manager'){
           this.selectedComponent = "metadata-dock-subclip-asset-partial-retrieve-as-child";
        }else if(this.$route.name == 'metadata-dock-bin-sub-clips-manager'){
           this.selectedComponent = "metadata-dock-subclip-partial-retrieve-as-child";
        }
        this.$router.push({
          name:this.selectedComponent,
          params:{subclipId: selectedSubclip.asset_id,subclipInfo:selectedSubclip, fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
        });
      },
      editTranscript(subclip){
        console.log("Subclips: EditTranscript ",this.$route.name, subclip)
        try{
            if(!this.controller.player.paused()){
                this.controller.player.pause();
            }
        }catch(e){console.log(e)}
        this.selectedSubclip = subclip;
        if(this.$route.name == 'sub-clips-manager'){
          this.selectedComponent = "subclips-asset-video-transcript"
        }
        this.$router.push({
          name:this.selectedComponent,
          params:{assetId: subclip.asset_id,subclipInfo:subclip, fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
        });
      },
      replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
      closeShareInChat(){
        this.openShareInChat = false;
      },
      handleShareAction(clip){
        // this.stopPlayerIfPlaying();
        this.assetDetailsOfSubclip = clip;
        this.openShareInChat = true;
      },
      isEnabled(priv) {
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
      },
      enterEditMode(clipId, isEditClicked){
        this.isINThumbnailCaptured = false;
        this.editSubclipClicked = isEditClicked;
        if(this.globalSettingsFromStartup?.subclip_settings?.enable_hard_subclips){
            this.capturedInThumbnail = '';
        }
        let payload = {}
        payload.params = {assetId: clipId}
        this.assetIndividualGetPromise = this.getAssetInfoFromServer(payload).then((data) => {
            this.assetDetailsOfSubclip =  data.asset;
            if(this.assetDetailsOfSubclip.department_info) {
              this.selectedDepartments = this.assetDetailsOfSubclip.department_info;
            }else{
              this.selectedDepartments = [];
            }
            this.editMetadata = true;
            try{this.setCaptureFrameInfo(data.asset)}catch(e){console.log(e)}
        }).catch((err) => {
          console.error('[getAssetInfoFromServer] fetch failed', err);
          throw err;
        });
        this.selectedAssetId = clipId;
        // this.editModeOfSubclip = clip._id;
        this.enableLoadMoreFields = false;
        setTimeout(() => {
          if(this.$refs.sequenceMetadataModel && this.$refs.sequenceMetadataModel.$refs && this.$refs.sequenceMetadataModel.$refs.slug_name_field_in_seq_metadata)this.$refs.sequenceMetadataModel.$refs.slug_name_field_in_seq_metadata.focus()
        }, 500);
      },
      unselectRow(){
        this.selectedAssetId = null;
      },
      getThumbnailOfSubclip(clip){
          if(clip && clip.markers && clip.markers.frame_thumbnail_uri){
           let thumbnail = Utils.convertToLoginIPDomainName(clip.markers.frame_thumbnail_uri);
            if(thumbnail.length == 0){
              return this.defaultThumbnail;
            }else{
              return thumbnail
            }
          }else{
              return this.defaultThumbnail;
          }
      },
      getWrapperComponent(){
        return this.$route.name;
      },
      getUpdatedSubclips(id){
        // try{this.markinMarkoutThumbnailObj.show = false;this.markinMarkoutThumbnailObj.capture = false; this.markinMarkoutPlayerListernerController.clearMakinMarkout();}catch(e){console.log(e)}
        this.editMetadata = false;
        // this.clearMarker = true;
        this.getSubclipsOfSelectedAssets(false);
        this.selectedAssetId = id;
        this.$nextTick(() => {
          let element = null;
          element = this.$refs['subcliprows'].find(el => {
            return el.id === id;
          });
          Utils.scrollToElement(element,this.$refs.subcliprowswrapper);
        });
      },
      getFileName(fileInfo){
        let f = fileInfo.slug_name?fileInfo.slug_name:fileInfo.file_name
        try{
           return f.replace("_${IN}_${OUT}","").replace("_${IN}","").replace("_${OUT}","");
        }catch(e){console.log(e)}
        return f;
      },
      setSliderMarkinMarkoutPosition(playinfo){
         let start = playinfo.markers.start , end = playinfo.markers.end;
         let reg = new RegExp(':');
         if(reg.test(playinfo.markers.start)){
          start = this.hhmmssToMs(playinfo.markers.start) * 1000;
          end = this.hhmmssToMs(playinfo.markers.end) * 1000;
         }
         
         if(this.$refs.sliderComponentRef){
              this.$refs.sliderComponentRef.value = [start , end];
              this.$refs.sliderComponentRef.setPositionFromValue(start);
         }
         
         if(this.$refs.markinMarkoutActionRef){
             this.$refs.markinMarkoutActionRef.setMarkinLabelValueWithFF(start/1000)
             this.$refs.markinMarkoutActionRef.setMarkoutLabelValueWithFF(end/1000);
         }
         
         if(this.$refs.videoPlayerRef){
            this.$refs.videoPlayerRef.$el.querySelector('video').currentTime = start/1000;
         }
      },
      setCaptureFrameInfo(clip){
          console.log("[setCaptureFrameInfo]",clip);
          this.markinMarkoutThumbnailObj.show = true;
          this.markinMarkoutThumbnailObj.filename = clip.slug_name;
          this.markinMarkoutThumbnailObj.dur = clip.markers.start + ' - '+ clip.markers.end;
          this.markinMarkoutThumbnailObj.thumbnail = Utils.convertToLoginIPDomainName(clip.markers.frame_thumbnail_uri);
          this.markinMarkoutThumbnailObj.capture = false;
          if(clip && 'subclip_type' in clip && clip.subclip_type != 'hard'){
             this.setSliderMarkinMarkoutPosition(clip);
          }else{
             if(this.$refs.markinMarkoutActionRef){
                this.$refs.markinMarkoutActionRef.resetMarkinMarkoutSlider();
             }
          }
      },
      addSubclip(data){
        console.log("[addSubclip]",data);
        let payload1 = this.$refs.sequenceMetadataModel.getSequenceMetadataMap(false);
        if(!payload1){
          console.log("Metadata: Mandatory fields were missed. Hence returning.")
          return false
        }
        if(!this.editSubclipClicked && this.globalSettingsFromStartup.subclip_settings && this.globalSettingsFromStartup.subclip_settings.enable_hard_subclips){
          if(this.subclipSharePath.length == 0 && !this.globalSettingsFromStartup.subclip_settings.select_global_path){
            alert("Path field is empty, Configure in global settings");
            return false;
          }
          if(this.subclipSharePath.length == 0 && this.globalSettingsFromStartup.subclip_settings.select_global_path){
            alert("Path field is empty, select by browsing");
            return false;
          }
          payload1['subclip_bin_path'] = this.subclipSharePath;
        }
        if ("asset_state" in data){
          payload1._id = data._id
        }else{
          payload1._id = data.asset_id
        }

        if(this.globalSettingsFromStartup.enable_department){
          if(!this.selectedDepartments || Object.keys(this.selectedDepartments).length == 0){ 
            alert(this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?"Please select " +this.globalSettingsFromStartup.department_alias.alias_name:"Please select Department")
            return;
          }
          payload1["department_id"]  = this.selectedDepartments._id;
        }

        const setMarkers = () =>{
          try{ // not a critical code if breaks also it will not affect much
            if(this.isINThumbnailCaptured){
                this.isINThumbnailCaptured = false; // reset first, so a thrown error below can't leave this stuck true
                let markObj = this.$refs.sliderComponentRef.getStartEndTime();
                payload1['markers'] = {}
                payload1['markers']['start'] = markObj.start;
                payload1['markers']['end'] = markObj.end;
                payload1['markers']['frame_thumbnail_uri'] = this.$refs.markInMarkOutThumbnail.getImageThumbnail();
            }else{
                let markObj = this.$refs.sliderComponentRef.getStartEndTime();
                //let markout = this.assetDetailsOfSubclip?.markers?.end;
                // if(markObj.end != markout){
                  payload1['markers'] = {}
                  payload1['markers']['start'] = markObj.start;
                  payload1['markers']['end'] = markObj.end;
                // }
            }
          }catch(e){console.log('mark-in/mark-out capture failed:', e)}
        }

        if(this.isPlayerLoadError){
          console.log("[Player] not loaded error.");
        }else{
           if(data && 'subclip_type' in data && data.subclip_type != 'hard'){
             setMarkers();
           }
           try{
              if(!this.editSubclipClicked && this.globalSettingsFromStartup.subclip_settings 
                  && this.globalSettingsFromStartup.subclip_settings.enable_hard_subclips){
                  delete payload1['markers']; //don't send markers on put for hard subclip
              }
           }catch(e){console.log(e)}
        }

        try{
          let IN = parseInt(this.$refs.sliderComponentRef.value[0]);
          let OUT = parseInt(this.$refs.sliderComponentRef.value[1]);
          payload1.slug_name = payload1.slug_name.replace(/\$\{IN\}/g,  IN).replace(/\$\{OUT\}/g, OUT);
        }catch(e){console.log(e)}

        this.updateAssetInfo(payload1).then((data) => {
          if (data.statusCode==200){
              this.$toast.success(data.message); 
              this.markinMarkoutThumbnailObj.capture = false;
              this.editMetadata = false;
              this.editSubclipClicked = false;
              if(this.globalSettingsFromStartup.subclip_settings && this.globalSettingsFromStartup.subclip_settings.enable_hard_subclips){
                sessionStorage.setItem('subclip-path', this.subclipSharePath);
              }
              setTimeout(() => {
                    document.getElementById(this.selectedAssetId).scrollIntoView({
                      behavior: 'smooth'
                    });
                    // this.$nextTick(() => {
                    //   this.$refs.slugname[0].focus();
                    // })
                }, 500);
          }else{
              this.$toast.error(data.message);
          }
        })
        this.editModeOfSubclip = null;
        this.selectedAssetId = data._id
      },
      cancelAddition(assetDetails){
        this.isINThumbnailCaptured = false;
        this.editModeOfSubclip = null;
        this.editMetadata = false;
        if(this.editSubclipClicked == false){
          this.deleteSelectedSubclip(assetDetails._id)
        }
        this.editSubclipClicked = false;
        this.markinMarkoutThumbnailObj['thumbnail'] = '';
        this.markinMarkoutThumbnailObj.show = false;
        // this.selectedAssetId = clip._id
        setTimeout(() => {
          document.getElementById(this.selectedAssetId).scrollIntoView({
            behavior: 'smooth'
          });
          // this.$nextTick(() => {
          //   this.$refs.slugname[0].focus();
          // })
      }, 1000);
      },
      // openMetaDataOverlayPanel(id){
      //   let payload = {}
      //   payload.params = {assetId: id}
      //   this.getAssetInfoFromServer(payload).then((data) => {
      //       this.assetDetailsOfSubclip =  data.asset;
      //       this.editMetadata = true;
      //       try{this.setCaptureFrameInfo(data.asset)}catch(e){console.log(e)}
      //   })
      // },
      picPicZindex(zvalue, ref){
        if(this.$refs[ref].$el.style)this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
      },
      showAssetDetailsDockCloseMiniplayer(){
          if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
          this.openPip = true;
      },
      showAssetDetailsDockCloseMaximisedplayer(){
          if(this.isFullscreenPreviewAllowed()){
              this.openPip = false;
              this.showOtherFilesPreviewDialog = true;
              return;
          }
      },
      openPictureInPicture(){
        if(this.isFullscreenPreviewAllowed()){
          this.openPip = false;
          this.showOtherFilesPreviewDialog = true;
          return;
        }else{
          this.openPip = true;
          this.showOtherFilesPreviewDialog = false;
        }
      },
      isFullscreenPreviewAllowed(){
          let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
          return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
      },
      previewProxy(fileInfo){
        this.selectedFileInfo = {};
        this.selectedFileInfo = fileInfo;
        this.$nextTick(() => {
          this.openPictureInPicture()
        })
      },
      getFilePath(fileInfo){
        if ("path" in fileInfo){
            return fileInfo.path
        }else{
            return this.getCategoryRoutefromId(fileInfo.category_id)
        }
      },
      updatePlayerProgress(time){
        if(!Object.keys(this.progressElMap).length){ // to avoid DOM operation of finding element we kept in global variable
            this.progressElMap['el'] = this.$refs.videoPlayerRef.$el.querySelector('.player-current-time-division .currrent-time')
        }
        this.progressElMap.el.textContent = Utils.getExactDuationInSeconds(time , this.frameRate, '.');
      },
      setController(controller){
            this.controller = controller;
      },
      showActionsOnPlayer(){
          this.actionsOnPlayer = ! this.actionsOnPlayer;
      },
      maximisePlayer(){
          this.$emit("maximisePlayer");
      },
      closeMiniPlayer(){
          this.$emit("closeMiniPlayer")
      },
      getThumbnailPath(file){
        return Utils.getThumbnailPathfromFileInfo(file)
      },
      getLowresPath(file){
        return Utils.getLowresPathfromFileInfo(file)
      },
      getAudiowaveform(file){
          return Utils.getAudiowaveformFromFileInfo(file)
      },
      getUnique(array){
      var uniqueArray = [];
      
      // Loop through array values
      for(let i=0; i < array.length; i++){
          if(uniqueArray.indexOf(array[i]) === -1) {
              uniqueArray.push(array[i]);
          }
      }
      return uniqueArray;
      },
    closeMetadataManager(){
      // this.$emit("close");
      this.closeModalCompoent()
    },
    humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
    },
    selectCategoryforAnAsset(){
        this.$emit("selectCategoryFromBrowse");
        this.cancelMetadataDockFields()
    },
    getCategoryRoutefromId(){
      return this.route
    },
    deleteSelectedSubclip(id){
      if(confirm(
          `Are you sure you want to delete selected subclip?`
        )){
          let payload = {};
          payload = {_id: id}
            this.deleteSubclip(payload).then((data) => {
              if(!Utils.isAcceptedStatusCode(data.statusCode)){
                    this.$toast.error(data.message);
              }else{
                this.$toast.success(data.message);
                this.subclipsList = this.subclipsList.filter(e => e._id != id)
              }
          })
        }
    },
    updateSelectedDepartments(value){
      this.selectedDepartments = value;
    },
    async setAssetInfo(info){
      this.assetDetails = {}
      Object.assign(this.assetDetails, info);
      if(this.assetDetails && this.assetDetails.frame_rate)
          this.frameRate = this.assetDetails.frame_rate;
      if(Object.keys(this.assetDetails).includes("custom_metadata")){
        Object.assign(this.assetCustomMetadata["custom_metadata"], this.assetDetails.custom_metadata);
      }else{
        this.assetDetails["custom_metadata"] = [];
      }
      if(this.assetDetails.proxy_info && this.assetDetails.proxy_info.thumbnail_uri){
        this.thumbnailFromServerUrl = Utils.convertToLoginIPDomainName(this.assetDetails.proxy_info.thumbnail_uri);
      }
      this.slugName = `${this.assetDetails.slug_name}`
      if(this.assetDetails && 'slug_name' in this.assetDetails){
          this.assetDetails.slug_name = ""+this.assetDetails.slug_name+"_${IN}_${OUT}";
      }
      if (this.assetDetails.category_id){
        if(this.assetDetails.category_id.trim().length > 0){
          this.getCategoryTreefromId({ params: { catalog_id:this.assetDetails.category_id}}).then((route)=>{
            let catalogPath = route
            let catalogPathList = catalogPath.split(" > ")
            this.categoryDetails.name = catalogPathList[catalogPathList.length - 1]
            // this.categoryDetails.name = (catalogPathList[catalogPathList.length - 1] + " [ " + route + "] ");
            this.categoryName = this.categoryDetails.name;
            this.route = route
          })
        }
      }  
      this.getSubclipsOfSelectedAssets(false);
      if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("video")){
          this.videoOptions.sources.push({
                src:this.getLowresPath(this.assetDetails),
                type: "video/mp4"
            })
      }else if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("audio")){
        this.audioUrl = this.getAudiowaveform(this.assetDetails)
      }
      this.isLoaded=true 
    },
    checkContext(){
        if(this.$route.name && ['subclip-media-pipeline','subclip-manager-from-media-pipeline'].includes(this.$route.name)){
          return false;
        }
        return true;
    },
    refreshFileInfoAndShowAsset(fileId){
      let payload = {}
      if (this.assetId && ['catalogs-display','media-pipeline-stage'].includes(Utils.getCookieValue("context"))){
        payload.params = {assetId: this.assetId}
        this.getAssetInfoFromServer(payload).then((data) => {
            this.setAssetInfo(data["asset"])
        })
      }else{
        if(Utils.getCookieValue("context") == 'bins'){
            payload.params = {fileId: fileId, metadata:true}
            this.getFileInfoFromServer(payload).then((data) => {
                this.setAssetInfo(data["file"])
            })
        }else{
          if(this.assetId){
            payload.params = {assetId: this.assetId}
            this.getAssetInfoFromServer(payload).then((data) => {
                this.setAssetInfo(data["asset"])
            })
          }
        }
      }
    },
    subclipPostResponse(response){
      console.log("[subclipPostResponse]",response);
      if(this.editMetadata){
        alert("You have unsaved metadata, please save or cancel before continuing");
        return false;
      }
      /*
      if(this.$refs.markInMarkOutThumbnail && this.$refs.markInMarkOutThumbnail.imageSrc){
        this.latestCapturedThumbnail = this.$refs.markInMarkOutThumbnail.imageSrc;
      }
      */
     if(response?.upserted_data?._id) {
        this.assetDetailsOfSubclip = response.upserted_data;
        this.editModeOfSubclip = response.upserted_data._id;
      }
      this.editMetadata = true;
      this.slugNameData = this.assetDetailsOfSubclip.slug_name;
      this.descriptionData = null;
      this.selectedAssetId = this.assetDetailsOfSubclip._id;
      this.enableLoadMoreFields = false;
      this.enterEditMode(this.selectedAssetId,false)
      // if(this.$refs.slugname){
      //   setTimeout(() => {
      //     this.$refs.slugname[0].focus();
      //   }, 500);
      // }
      // this.getSubclipsOfSelectedAssets(false)
    },
    // generateSmartSubclips(assetInfo){
    //   console.log("generateSmartSubclips *****************")
    //   if('version_id' in assetInfo){
    //     let payload = {"version_id":assetInfo.version_id,"element_type": "assets","job_name": "Smart Subclips"}
    //     this.createNewJob(payload).then((data)=>{
    //       console.log("[generateSmartSubclips] Data is : ",data)
    //       if (Utils.isAcceptedStatusCode(data.statusCode)) {
    //         this.smartSubclipJobs = {
    //                 "job_id":data.job_id,"resource_name":data.resource_name,"state": data.state, 'status_info':data.status_info
    //         }
    //         if('message' in data){
    //           if (data.message.includes("Failed")) {
    //               this.$toast.warning(data.message);
    //           } else {
    //               this.$toast.success(data.message);
    //           }
    //         }else{
    //           this.$toast.success("Job submitted successfully")
    //         }
    //       } else {
    //         this.$toast.error(data.message);
    //       }
    //     });
    //   }else{
    //     alert("Invalid file version.")
    //   }
    // },
    // changeFilter(filterType="All"){
    //   if(filterType != this.selectedFilter){
    //     this.selectedFilter = filterType;
    //     if(filterType == 'All'){
    //       this.getSubclipsOfSelectedAssets(false,null)
    //     }else{
    //       this.getSubclipsOfSelectedAssets(false, 'Smart Subclips')
    //     }
    //   }
    // },
    getSubclipsOfSelectedAssets(isLoadMore, subclipType=null){
      let payload = {}
        payload.params = {asset_type:"subclip",master_asset_id:this.assetId,page:this.page,"metadata":"metadata"}
        if(subclipType){
          payload.params['subclip_type'] = subclipType;
        }
        this.getSubclipsFromServer(payload).then((data) => {
        this.totalSubclipsPages = data.page_count;
        let existingList = this.subclipsList;
        if(isLoadMore){
          existingList = existingList.concat(data.assets);
        }else{
          existingList = data.assets;
        }
        this.subclipsList = existingList.sort((a,b)=>{
            if (a.markers.start !== b.markers.start) {
              return a.markers.start - b.markers.start;
            } else {
              return a.markers.end - b.markers.end;
            }
          });
        })
    },
    loadMoreSubclips(e){
      if(this.subclipsList.length && !this.editMetadata){
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
                if(this.page < this.totalSubclipsPages){
                  this.page = this.page + 1;
                  this.getSubclipsOfSelectedAssets(true);
                }
                
            }
      }
    },
    closeMinimisedPlayer(){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = false;
    },
    highlightActivePlayBox(isplaying){
      console.log('isplaying',isplaying);
    },
    playSubclip(clipInfo){
      console.log(`[playSubclip playSubclip]`,clipInfo);
      this.transcriptPlayObject = {};
      if(this.isAudioFile){
          this.listenAudioClickedRow(clipInfo);
          return;
      }
      this.subclipRowClicked(clipInfo)
    },
    playMarkinMarkoutBasedOnDuration(playinfo, playOnEachClick=false){
         console.log('>>>>>>>>>>',playinfo,playOnEachClick);
         let start = playinfo.markers.start , end = playinfo.markers.end;
         let reg = new RegExp(':');
         if(reg.test(playinfo.markers.start)){
          start = this.hhmmssToMs(playinfo.markers.start) * 1000;
          end = this.hhmmssToMs(playinfo.markers.end) * 1000;
         }
          this.markinMarkoutPlayerListernerController.setSubclipMarkersBasedOnVideoDuration(start,end);
          this.markinMarkoutPlayerListernerController.preview.call(this,playOnEachClick);
          return {start:start,end:end};
    },
    subclipRowClicked(info){
        /*
        if(info && info.markers && info.markers.end){
           console.log(`info.markers.end`,info.markers.end,info);
           this.setProgressLabel(this.getDurationInSeconds(info.markers.end));
        }*/
        this.selectedAssetId = info._id;
        this.$router.push({
          params:{subclipId: this.selectedAssetId,subclipInfo:info, fileInfo:Object.assign({}, this.assetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
        })
        try{
          if(!this.controller.player.paused()){
            this.controller.player.pause();
          }
        }catch(e){console.log(e)}
        try{
          this.playMarkinMarkoutBasedOnDuration(info);
        }catch(e){console.log(e);}
       try{this.setCaptureFrameInfo(info)}catch(e){console.log(e)}
    },
    handleSubclipsNotification(notification){
    notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    if(notification.message){
        let subclip_info = notification.message;
        // converting new format of "parent_path" to older format
        // newFormat ="parent_path": [
        //   {
        //     "_id": "64d36749e30e786e1a393924",
        //     "catalog_name": "Fusion AI",
        //     "parent_id_path": [
        //       "catalog_id://0/63c907b570b3c8c55024bcf2"
        //     ],
        //     "parent_path": {
        //       "id": "catalog_id://0/63c907b570b3c8c55024bcf2",
        //       "value": "catalog://0/CATALOG"
        //     }
        //   }
        // ],
        // oldFormat ="parent_path": [
        //   {
        //     "id": "catalog_id://0/63c907b570b3c8c55024bcf2",
        //     "value": "catalog://0/CATALOG"
        //   }
        // ]

        if('parent_path' in subclip_info){
          let parentPathList = []
          for(let item of subclip_info["parent_path"]){
            if('value' in item){
              parentPathList.push(item)
            }else if('catalog_name' in subclip_info){
              const parent_id = item.parent_id_path[0];
              const catalog_name = item.catalog_name;
              const _id = item._id;

              const new_item = {
                "id": `${parent_id}/${_id}`,
                "value": `catalog://0/CATALOG/${catalog_name}`
              };

              parentPathList.push(new_item);
            }
          }
          subclip_info["parent_path"] = parentPathList
        }
        if (notification.message_type == NotifierConstants.assetRemovedCreatedNotification){
            this.subclipsList = this.subclipsList.filter((bin)=>bin._id!=subclip_info.asset_id)
        }else if(notification.message_type == NotifierConstants.assetCreatedNotification && subclip_info.asset_type == 'subclip' && subclip_info.master_asset_id && subclip_info.master_asset_id == this.assetDetails.asset_id){
          let existingList = this.subclipsList
          existingList.unshift(subclip_info)
          this.subclipsList = existingList.sort((a,b)=>{
            if (a.markers.start !== b.markers.start) {
              return a.markers.start - b.markers.start;
            } else {
              return a.markers.end - b.markers.end;
            }
          });
        }else if(notification.message_type == NotifierConstants.assetModifiedNotification){
          let indexCheck = this.subclipsList.findIndex(e => e.asset_id == subclip_info.asset_id);
          if(indexCheck >= 0){
            this.subclipsList[indexCheck] = subclip_info;
          }
        }
      }
    },
    handleFileUpdateNotification(notification){ //NOT GETTING FILE_UPDATED NOTIFICATION FOR SUBCLIPS
    notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    if(notification.message){
        let path = notification.message.path
        let parent_path = notification.message.parent_path;
        if (this.assetDetails.path == path){
            if (this.assetDetails.mime_type.startsWith("video")){
                Object.assign(this.assetDetails, notification.message)
                this.videoOptions.autoplay=false;
                this.videoOptions.sources = [{
                        src:this.getLowresPath(notification.message),
                        type: "video/mp4",
                    }]
                // if (  this.controller.player){
                //     this.controller.restartPlayer(this.videoOptions.sources[0]);
                // }
            }else if (this.assetDetails.mime_type.startsWith("audio")){
                this.audioUrl = this.getAudiowaveform(this.assetDetails)
            }else if (this.assetDetails.mime_type.startsWith("image")){
                Object.assign(this.assetDetails, notification.message)
            }
            console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
        }
        
        if(this.subclipsList.length) {
            const subclipIndex = this.subclipsList.findIndex(
              subclip => subclip._id === notification.message.asset_id
            );

            if(subclipIndex === -1) return;

            const { markers, proxy_info: proxyInfo } = notification.message;

            if(markers && Object.keys(markers).length) {
              this.$set(this.subclipsList[subclipIndex], 'markers', markers);
            }

            if(proxyInfo && Object.keys(proxyInfo).length) {
              this.$set(this.subclipsList[subclipIndex], 'proxy_info', proxyInfo);
            }
          }
        }
    },
    // handleJobNotification(notification){
    //     notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    //     if(notification.message){
    //         let jobInfo = Object.assign({}, notification.message);
    //         if(this.smartSubclipJobs && 'job_id' in this.smartSubclipJobs && this.smartSubclipJobs.job_id == jobInfo.job_id){
    //           this.smartSubclipJobs['state'] = jobInfo.state;
    //           this.smartSubclipJobs['status_info'] = jobInfo.status_info;
    //         }
    //     }
    // },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.assetCreatedNotification, NotifierConstants.assetModifiedNotification, NotifierConstants.assetRemovedCreatedNotification],
            callback:this.handleSubclipsNotification,
            parent:"subclips"})
      this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"subclips"})
    //   this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleJobNotification,parent:"Subclips"});

    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.assetCreatedNotification, NotifierConstants.assetModifiedNotification, NotifierConstants.assetRemovedCreatedNotification],
            callback:this.handleSubclipsNotification,
            parent:"subclips"})
      this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"subclips"})
    //   this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleJobNotification,parent:"Subclips"});
    },
    closeModalCompoent(){
      this.$emit("close",true)
      if (Object.keys(this.parentRouteInfo).length!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.replace({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.replace({
          name: "explorer",
        })
      }
    },
    playerMetadataLoaded(){
        this.setProgressLabel(this.controller.player.duration());
    },
    formatDurationHHMMSS_or_MMSS(duration) {
      return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
    /*     const date = new Date(duration * 1000); // convert to milliseconds
        const hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const seconds = date.getUTCSeconds();
        
        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } */
    },
    getDurationFormat(duration){
        const date = new Date(duration * 1000); // convert to milliseconds
        const hours = date.getUTCHours();
        if(hours > 0){
            return '00:00:00.00'
        }else{
            return '00:00.00'
        }
    },
    setProgressLabel(duration){
       try{
        [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
            el.remove();
        });
       }catch(e){console.log(e)}
       let progressBar = this.$refs.videoPlayerRef.$el.querySelector('.vjs-control-bar');
       let currentProgressEl = document.createElement('div');
       currentProgressEl.classList.add('player-current-time-division');
       currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
       progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
    },
    handleKeyBoardShortcuts(event){
        if(this.isMediaEditWindowEvent()){
           console.log('media edit window ignored');
           return true;
        }
        let keyCode = event.keyCode || event.which;
        console.log(keyCode,event);
        let pressedElement = String(event.target.nodeName).toLowerCase();
        if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
        console.log('execute keycode');
        let actionComponentRef = null;
        if(this.isAudioFile){
           actionComponentRef =  this.$refs.audioMarkinMaroutActionRef;
        }else{
          actionComponentRef =  this.$refs.markinMarkoutActionRef;
        }

        if(keyCode === 73){ // 'i' key for markin
             actionComponentRef.markin();
        } 

        if(keyCode === 79){ // 'o' key for markout
             actionComponentRef.markout();
        } 
     
        if(keyCode === 80){ // 'p' key for preview markin,markout region [video]
              actionComponentRef.playMarkinMarkoutPreview();
        } 

        if(keyCode === 32){ // 'spacebar' key for toggle play->pause
            actionComponentRef.playPauseToggle();
        } 

        if(keyCode === 57){ // '9' key for backward video by 1sec
             actionComponentRef.forwardBackwardVideoBy1Sec('backward');
        } 

        if(keyCode === 48){ // '0' key for forward video by 1sec
           actionComponentRef.forwardBackwardVideoBy1Sec('forward'); 
        } 

        if(keyCode === 189){ // '-' key for backward video by 1 frame
            actionComponentRef.forwardBackwardVideoByFrame('backward');
        }

        if(keyCode === 187){ // '=' key for forward video by 1 frame
             actionComponentRef.forwardBackwardVideoByFrame('forward');
        }

        if(keyCode === 67){ // 'c' key for clearing markin,markout region
            actionComponentRef.resetMarkinMarkoutSlider();
        }

        if(keyCode === 70){ // 'f' key for clearing markin,markout region
            actionComponentRef.captureFrame();
        }

        if(keyCode === 72){ // 'h'  fast forward - play backward
            actionComponentRef.fastForwardPlayBackward();
        }

        if(keyCode === 74){ // 'j' fast forward - play forward
            actionComponentRef.fastForwardPlayForward();
        }
                
        if(keyCode === 82){ // 'r' reset fast forward
            actionComponentRef.resetFF();
        }

    },
    ...mapActions("files", ["getFileInfoFromServer"]),
    ...mapActions("tags", ["getTagsOnAutocomplete"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("assets", ["updateAssetInfo","getAssetInfoFromServer","deleteSubclip","getSubclipsFromServer","insertSubClip"]),
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("upload",["attachCustomThumbnail"]),
    ...mapActions("transcript", ["getSubclipTransctiptFromServer"]),
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications();
    window.removeEventListener('keydown', this.handleKeyBoardShortcuts);
  },
  watch:{
    "$route.fullPath" : function(newVal, oldVal){
      if (newVal != oldVal){
        this.editMetadata = false;
      }
    },
    // subclipsList(newVal,oldVal){
    //   console.log("watcher subclipsList ::::::::::::: ",typeof(newVal), typeof(oldVal))
    //   if(this.subclipsList && this.subclipsList.filter(op=>op.subclip_type == 'smart').length > 0){
    //     this.viewSubclipTypeFilters = true;
    //     return;
    //   }
    //   this.viewSubclipTypeFilters = false;
    // }
  },
  async created(){
    this.componentName = this.$route.name;
    this.editMetadata = this.$route.params.subclipId?true:false
    this.selectedAssetId = this.$route.params.subclipId?this.$route.params.subclipId:null
    // this.slugNameData = this.$route.params.subclipInfo?this.$route.params.subclipInfo.slug_name:null;
    // this.descriptionData = this.$route.params.subclipInfo?this.$route.params.subclipInfo.metadata.description:null;
    Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    if(!this.fileInfo){
      this.fileInfo = {};
    }
    Object.assign(this.fileInfo, this.$route.params.fileInfo?this.$route.params.fileInfo:{})
    if (Object.keys(this.fileInfo).length == 0){
      let data = await this.getAssetInfoFromServer({params:{assetId:this.$route.params.assetId}})
      this.assetId = this.$route.params.assetId
      Object.assign(this.fileInfo, data.asset);
    }
    if(this.fileInfo && 'file_uid' in this.fileInfo){
      this.fileId = this.fileInfo.file_uid
    }
    this.isLoaded=false;
    if (!this.assetId){
      if ("asset_id" in this.fileInfo){
        this.assetId = this.fileInfo.asset_id
      }else{
        this.assetId = this.fileInfo._id;
      }
    }
      try{
        this.capturedInThumbnail = this.getThumbnailPath(this.fileInfo);
      }catch(e){console.log(e)}
     if(this.editMetadata){
      this.enterEditMode(this.selectedAssetId,true)
      // setTimeout(() => {
      //     document.getElementById(this.editModeOfSubclip).scrollIntoView({
      //       behavior: 'smooth'
      //     });
      //     this.$nextTick(() => {
      //       this.$refs.slugname[0].focus();
      //     })
      // }, 1000);
    }
    if(this.globalSettingsFromStartup.subclip_settings && this.globalSettingsFromStartup.subclip_settings.enable_hard_subclips){
      this.browseType.path = true;
      if(this.globalSettingsFromStartup.subclip_settings.select_global_path){
        this.subclipSharePath = this.globalSettingsFromStartup.subclip_settings.global_path;
      }else if(sessionStorage.getItem('subclip-path')){
        this.subclipSharePath = sessionStorage.getItem('subclip-path');
      }
      // else{
      //   this.subclipSharePath = this.globalSettingsFromStartup.subclip_settings.global_path;
      // }
    }
    this.refreshFileInfoAndShowAsset(this.fileId);
    this.registerforWebsocketNotifications()
   },
   mounted(){
      window.addEventListener('keydown', this.handleKeyBoardShortcuts);
      try{ 
           Utils.loadPluginBundles([{id:'smartsubclip_bundle_js',jsUrl:`${window.location.origin}/damplugins/ai_prompts/web/smartsubclip_bundle.js`}],'smartsubclip-component-loaded').then((event)=>{
            if(event && Array.isArray(event) && event.length){
                if(event[0].components['SmartSubclip']){
                  const ev = new Event('register-routes');
                  if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                    ev.pluginStore = event[0].pluginStore;
                  parent.document.body.dispatchEvent(ev);
                  Utils.loadCssBundle({id:'smartsubclip_bundle_css',cssUrl:`${window.location.origin}/damplugins/ai_prompts/web/smartsubclip_bundle.css`});
                  this.smartSubclipComponent = event[0].components['SmartSubclip'];
                }
              }
          });
        }catch(e){console.log(e)}
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$metadata-border-color-on-hover: #5a5a5a;
$learn-about-text-color:#e8912d;
$learn-about-color:#9a9620;
$learn-about-color-hover:#b7b327;
$close-icon-bg-on-hover:#3a3a3a;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
// $borderWidth: 5px;
// $howManySteps: 100;
// $animationTime: .001s;
// $size: 35px;

.load-more-btn{
  padding:2%;
  color:$learn-about-color
}

.load-more-btn:hover{
  color:$learn-about-color-hover;
  text-decoration: underline;
}

.li-style-change{
  background: $metadata-border-color-on-hover !important;
}

.selectedSubclipRow{
  border: 2px solid $active-blue !important;
}
.breadcrumb{
  padding: 0px !important;
  background: #181818 !important;
  li{
    position:relative;
    top:8px;
  }
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.readonlyDiv{
  background: transparent;
}

.readonly-field{
  color:$text-color;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }
 
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-background-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}


.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.modal-footer{
    justify-content: start;
}


.activeTag{
    color: $active-blue !important;
}

.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 7%;
    top: 45%;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  border: none !important;
  min-width: 250Px;
  border-bottom: 1px solid $active-blue !important;
  padding-inline-start:5px;
  padding-top: 3px;
  height:38px;
}

.svg-icon:hover{
  fill:#eee;
}

.text-light{
  color: #b6b6b6 !important;
}

.manage-department-styles{
  float: inline-start;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  color:#a1b427cf;
  width: 100%;
  text-align: end;
}

.manage-department-styles:hover{
  text-decoration: underline;
}

::v-deep{
  .tags-browse-dialog-modal{
     z-index: 9999 !important;
  }
 .add-tags-inside-tags-browse-dialog{
    z-index: 9999 !important;
 }
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$primary-background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: $primary-background;
}

.v-list-item--link:before{
  background-color:$primary-background;
}
.vjs_video_3-dimensions, .video-js{
    height:358px;
    width:100% !important;
}
.video-js{
    height:358px;
    width:100% !important;
}
  .media-edit-with-subclips[data-component="subclip-asset-partial-retrieve"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="subclip-asset-partial-retrieve"] .video-js{
      width: 100% !important;
      height:100% !important;
  }

  .media-edit-with-subclips[data-component="metadata-dock-subclip-partial-retrieve-as-child"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="metadata-dock-subclip-partial-retrieve-as-child"] .video-js{
      width: 100% !important;
      height:100% !important;
  }

  .media-edit-with-subclips[data-component="tagmetadata-subclip-partial-retrieve-as-child"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="tagmetadata-subclip-partial-retrieve-as-child"] .video-js{
      width: 100% !important;
      height:100% !important;
  }

  .media-edit-with-subclips[data-component="metadata-dock-subclip-asset-partial-retrieve-as-child"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="metadata-dock-subclip-asset-partial-retrieve-as-child"] .video-js{
      width: 100% !important;
      height:100% !important;
  }
  .media-edit-with-subclips[data-component="tagmetadata-subclip-asset-partial-retrieve-as-child"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="tagmetadata-subclip-asset-partial-retrieve-as-child"] .video-js{
      width: 100% !important;
      height:100% !important;
  }
  .media-edit-with-subclips[data-component="subclip-partial-retrieve"] .vjs_video_3-dimensions,
  .media-edit-with-subclips[data-component="subclip-partial-retrieve"] .video-js{
      width: 100% !important;
      height:100% !important;
  }

  .vjs-control-bar{
      display: flex !important;
      opacity:1 !important;
  }

  .fast-forward-info{
      position: absolute;
      top: 37px;
      inset-inline-start: 50%;
      transform: translateX(-50%);
     .fast-forward-current-speed{
        border: 1px solid rgb(74, 74, 74) !important;
        border-radius: 15px !important;
        width: 32px;
        padding: 4px;
        text-align: center;
        background: rgb(40, 45, 49) !important;
        height: 20px;
        justify-content: center;
        display: flex;
        align-items: center;
        font-size: 13px;
     }
  }

  .active-fast-forward{
     margin-bottom: 20px !important;
  }
}

.assets-details-in-metadata-manager{
    // height:calc(100% - 348px);
    overflow:auto;
    padding:0px 15px;
    margin-top:10px;
}


// .input-fields {
//   border: none !important;
//   min-width: 250Px;
//   border: none !important;
//   border-bottom: 1px solid $active-blue !important;
// }

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            text-align: end;
            margin-inline-end: 10px;
        }
        // .value-style{
        //     color: #b6b6b6;
        //     width: 70%;
        //     text-align: start;
        //     padding-inline-start:5px !important
        // }
    }
}


.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        // width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


.audio-player{
    //position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}


.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.outer {
  display: table;
  position: relative;
  top: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 22%;
  height: 138px;
  margin-bottom:10%;
  /* Whatever width you want */
  img{
    height:100%;
  }
  p{
    text-align: center;
    color: #666;
    font-size: 18px;
  }
}
.display-subclips{
  border: $secondary-border-color;
  border-radius: 4px;
  margin: 8px;
  position: relative;
  background:$primary-background;
  min-height: 130px;
}

.edit-icon-style{
  visibility: hidden;
  position: absolute;
  top:4px;
  inset-inline-end:5px;
  display:inline-flex;
  svg{
      margin-inline-end:5px;
  }
}

.basic-info{
  cursor: text;
  pointer-events: all;
  user-select: text;
}

.display-subclips:hover{
   border: 1px solid $bg-color-on-hover;
  .actions-on-subclips{
    visibility: visible;
    svg{
      margin-inline-end:5px;
    }
  }
}

.actions-on-subclips{
    position: absolute;
    inset-inline-end: 0px;
    border: $border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    top: 4px;
    inset-inline-end: 3px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-subclips{
    visibility: hidden;
}

.tag-metadata-overlay-panel-button{
    float: inline-end;
    $learn-about-text-color:#e8912d;
    $learn-about-color:#9a9620;
    $learn-about-color-hover:#b7b327;
    padding: 4px 11px 4px 4px;
    color: $learn-about-color;
}
.tag-metadata-overlay-panel-button:hover{
    text-decoration: underline;
    color: $learn-about-color-hover;
}

.common-input-field{
    width: 98%;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: 1px solid #343434;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
}

.input-text-field{
    height: 38px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
}

.add-border{
      border: $border-color;
  }

.primary-btn-style{
    margin-top: 1%;
    display: flex;
    justify-content: flex-end;
    margin-inline-end: 2%;
    button{
        justify-content: center;
        height: 32px;
        width: 60px;
        font-size: 13px;
        display: flex;
    }
}

textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}
.comm-input-field-style{
    background: $primary-background !important;
    float: inline-start;
    width:100%;
    padding: $input-field-padding;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.subclip-thumbnail{
    width:180px;
    padding:5px;
    border-radius: 5px;
    img{
        object-fit: contain;
    }
}
.subclip-thumbnail:hover{
    .bi-play-circle-fill{
        fill:$close-icon-bg-on-hover;
    }
}

.play-icon{
    position: absolute;
    top: 38%;
    width: 100%;
    fill: #2727278c;
    inset-inline-start: -2px;
    cursor: pointer;
}

.thumbnail-view-duration-label{
    font-size: 14px;
    background: #01868c;
    padding: 1px 5px;
    justify-content: start;
    display: flex;
    border-radius: 3px;
    color: #000 !important;
    div{
        color: #eee !important;
    }
  }

  .thumbanils-display{
    height:143px;
    display:inline-flex;
    padding-inline-start: 8%;
    .generated-thumbails,.custom-thumbanil{
        height: 120px;
        width: 180px;
        border: 1px solid #161616;
        margin-inline-end: 10px;
        position:relative;
        padding:3px;
      }
    .custom-thumbanil{
      position:relative;
      align-items: center;
      justify-content: center;
      color: $add-button-text-color;
      display: flex;
    }
  }
  
  .applyborder{
    border: 3px dotted $add-button-border-color !important;
    border-radius: 5px;
  }
  
  .applyborder:hover{
    border: 3px dotted $add-button-border-on-hover !important; 
    border-radius: 5px;
    .replace-uploaded-thumbnail{
      color:#eee;
    }
  }
  
  .replace-uploaded-thumbnail{
    background: #363636a1;
    color: #eee;
    padding: 3px;
    border-radius: 7px;
    svg{
      margin-top:unset !important;
    }
  }
  
  .custom-thumbanil:hover{
    color: $add-button-text-color-hover;
  }

  .change-thumbnail{
    position: absolute;
    border: 1px solid #4a4949;
    inset-inline-end: 19px;
    padding: 9px 10px;
    bottom: 0px;
    background: #1a1a1a;
    width: max-content;
    color:#eee;
  }
  .unselected-image{
    opacity:0.2;
  }

  .activeDiv{
    border:2px solid $active-blue !important;
    border-radius: 5px;
    img,canvas{
      opacity:1;
    }
  }

//   .select-filters{
//     display: flex;
//     padding: 5px;
//     position: sticky;
//     top: 0px;
//     background: #1a1d21;
//     z-index: 999;
//     overflow-x:auto;
//     .notification-filters{
//         border:$border-color;
//         border-radius: 20px;
//         padding: 13px;
//         display: flex;
//         align-items: center;
//         margin-inline-end: 5px;
//         height:30px;
//         color: $secondary-text-color;
//         // background: $tags-background-color;
//     }
//   }

//   .activeFilter{
//     color: #007bfc !important;
//     border:1px solid #007bfc !important;
//   }


//   .progress {
//   width: $size;
//   height: $size;
//   line-height: $size;
//   background: none;
//   box-shadow: none;
//   position: relative;
//   border-radius: 30px !important;
//   border: 0px solid #202729;
//   &:after {
//     content: "";
//     width: 100%;
//     height: 100%;
//     border-radius: 50%;
//     border: $borderWidth solid #202729;
//     position: absolute;
//     top: 0;
//     inset-inline-start :0;
//   }
//   > span {
//     width: 50%;
//     height: 100%;
//     overflow: hidden;
//     position: absolute;
//     top: 0;
//     z-index: 1;
//   }
//   .progress-left {
//     inset-inline-start :0;
//   }
//   .progress-bar {
//     width: 100%;
//     height: 100%;
//     background: none;
//     border-width: $borderWidth;
//     border-style: solid;
//     position: absolute;
//     top: 0;
//     border-color: #009abd;
//   }
//   .progress-left .progress-bar {
//     inset-inline-start :100%;
//     border-top-right-radius: ($size/2);;
//     border-bottom-right-radius: ($size/2);;
//     border-inline-start: 0;
//     -webkit-transform-origin: center left;
//     transform-origin: center left;
//     //animation: loading-2 1.5s linear forwards 1.8s;
//   }
//   .progress-right {
//     inset-inline-end :0;
//     .progress-bar {
//       inset-inline-start :-100%;
//       border-top-left-radius: ($size/2);;
//       border-bottom-left-radius: ($size/2);;
//       border-inline-end: 0;
//       -webkit-transform-origin: center right;
//       transform-origin: center right;
//       //animation: loading-1 1.8s linear forwards;
//     }
//   }
//   .progress-value {
//     display: flex;
//     border-radius: 50%;
//     font-size: 10px;
//     text-align: center;
//     line-height: 20px;
//     align-items: center;
//     justify-content: center;
//     height: 100%;
//     width: 100%;
//     font-weight: 300;
//     div {
//       //margin-top: 10px;
//     }
//     span {
//       font-size: 12px;
//       text-transform: uppercase;
//     }
//   }
// }
// .file-name-span{
//     display: -webkit-box;
//     -webkit-box-orient: vertical;
//     -webkit-line-clamp: 1;
//     line-clamp: 1;
//     overflow: hidden;
//     word-break: break-word;
//     overflow-wrap: break-word;
//     width: 94%;
// }

// @for $i from 1 through $howManySteps {
// 	$stepName: ($i*(100 / $howManySteps));

// 	//animation only the left side if below 50%
// 	@if $i <= ($howManySteps/2) { 
// 		.progress[data-percentage="#{$stepName}"] {
// 			.progress-right .progress-bar {
// 				animation: loading-#{$i} $animationTime linear forwards;
// 			}
// 			.progress-left .progress-bar {animation: 0;}
// 		}
// 	}
// 	//animation only the right side if above 50%
// 	@if $i > ($howManySteps/2)  {  
// 		.progress[data-percentage="#{$stepName}"] {
// 			.progress-right .progress-bar {
// 				animation: loading-#{($howManySteps/2)} $animationTime linear forwards; //set the animation to longest animation
// 			}
// 			.progress-left .progress-bar {
//       animation: loading-#{$i - ($howManySteps/2)} $animationTime linear forwards $animationTime;
//     }
// 		}
// 	}
// }

// //animation
// @for $i from 1 through ($howManySteps/2) { 
// 	$degrees: (180/($howManySteps/2));
// 	$degrees: ($degrees*$i);
// 	@keyframes loading-#{$i}{
//     0%{
//         -webkit-transform: rotate(0deg);
//         transform: rotate(0deg);
//     }
//     100%{
//         -webkit-transform: rotate($degrees);
// 			transform: rotate(#{$degrees}deg);
//     }
// 	}
// }

.share-in-chat-subclip{
   z-index: 9999 !important;
}

.loading-subclip-actions{
    padding: 0;
    margin: 6px;
    padding-left: 16px;
    padding-right: 16px;
    color: $dull-text-color;
}

</style>